import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['localeOverlay', 'menuItem'];

  static values = {
    activeClass: String,
  };

  updateOverlay(event) {
    this.localeOverlayTarget.textContent = event.params.locale.replace(
      '-001',
      '-INT',
    );
  }
  switchLocaleInput(event) {
    this.element.querySelectorAll('[data-locale-input]').forEach((element) => {
      element.hidden =
        element.getAttribute('data-locale-input') !== event.params.locale;
    });

    this.menuItemTargets.forEach((element) => {
      if (
        element.getAttribute(`data-${this.identifier}-locale-param`) ===
        event.params.locale
      ) {
        element.classList.add(this.activeClassValue);
      } else {
        element.classList.remove(this.activeClassValue);
      }
    });
  }
}
